import apiClient from '../connections/api'

const PDF_BASE_URL = process.env.REACT_APP_API_URL || 'http://127.0.0.1:5001'

export default {
    createPdf: (pdfContent, reportId, sapId, guide, numEquip) => {
        const requestBody = {
            pdfContent,
            reportId,
            sapId,
            guide,
            numEquip
        }
        return apiClient.post('/pdf-maker/createPdf', requestBody)
    },
    createPdfDoc: (doc) => {
        return apiClient.post('/pdf-maker/createPdfDoc', doc)
    },
    createPdfDocWithNotification: (doc, userId) => {
        return apiClient.post('/pdf-maker/createPdfDocWithNotification', { reportData: doc, userId })
    },
    createSummaryPdf: (doc) => {
        return apiClient.post('/pdf-maker/createSummaryPdf', { reportData: doc })
    },
    createNoChecksSummaryPdf: (doc) => {
        return apiClient.post('/pdf-maker/summaryNoChecks', { reportData: doc })
    },
    // New function to construct the full PDF URL
    viewPdf: (filePath) => {
        if (!filePath) {
            return ''
        }
        // If filePath is already an absolute URL, return it directly.
        if (filePath.startsWith('http://') || filePath.startsWith('https://')) {
            return filePath
        }
        // Otherwise, treat it as a relative path and join with the base URL.
        const cleanedPath = filePath.startsWith('/') ? filePath : `/${filePath}`
        return `${PDF_BASE_URL}${cleanedPath}`
    }
}
